import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { AttachmentState } from "./types";

export const useAttachmentStore = create<AttachmentState>()(
  devtools(
    (set, get) => ({
      files: [],
      isDragging: false,
      hasUnsupportedFiles: false,

      addFiles: (files) => {
        const { files: currentFiles } = get();
        // Filter out duplicates based on name and size
        const newFiles = files.filter(
          (file) =>
            !currentFiles.some(
              (existing) =>
                existing.name === file.name && existing.size === file.size,
            ),
        );
        if (newFiles.length > 0) {
          set({ files: [...currentFiles, ...newFiles] });
        }
      },

      removeFile: (id) => {
        set((state) => ({
          files: state.files.filter((file) => file.id !== id),
        }));
      },

      setIsDragging: (isDragging) => set({ isDragging }),

      setHasUnsupportedFiles: (hasUnsupportedFiles) =>
        set({ hasUnsupportedFiles }),

      clearAll: () => set({ files: [] }),
    }),
    {
      name: "attachment-store",
    },
  ),
);
